<template>
    <div>
        <div class="d-flex justify-content-center mb-3">
            <ul class="nav nav-pills">
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'atend' ? 'active' : ''" @click.prevent="abrir('atend')">
                        <i class="fa fa-play mr-2" aria-hidden="true"></i>
                        Atendimento
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'aplic' ? 'active' : ''" @click.prevent="abrir('aplic')">
                        <i class="fa-solid fa-clipboard-check mr-2"></i>
                        Aplicação
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'apraz' ? 'active' : ''" @click.prevent="abrir('apraz')">
                        <i class="fas fa-clock mr-2"></i>
                        Aprazamento
                    </a>
                </li>
                <li class="nav-item" v-if="tem_valid">
                    <a class="nav-link" href="#" :class="aba == 'valid' ? 'active' : ''" @click.prevent="abrir('valid')">
                        <i class="fa-solid fa-prescription-bottle-medical mr-2"></i>
                        Validação Prescrição
                    </a>
                </li>
                <li class="nav-item" v-if="false && $store.state.user.id_usuario == 1">
                    <a class="nav-link" href="#" :class="aba == 'infusao' ? 'active' : ''" @click.prevent="abrir('infusao')">
                        <i class="fas fa-syringe mr-2"></i>
                        Planejamento Infusão
                    </a>
                </li>

                <li class="nav-item" v-if="false">
                    <div class="btn-group dropleft">
                        <button class="btn btn-light dropdown-toggle" type="button" id="triggerId" data-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">
                            <i class="fas fa-ellipsis-h ml-2"></i>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="triggerId">
                            <a class="dropdown-item" href="#" :class="aba == 'checagem-consumo' ? 'active' : ''" @click.prevent="abrir('checagem-consumo')">
                                Checagem Consumo
                            </a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <aprazamento v-if="aba == 'apraz'" />
        <aplicacao v-if="aba == 'aplic'" />
        <atendimento-enfermagem v-if="aba == 'atend'" />
        <plano-infusao v-if="aba == 'infusao'" />
        <validacao-prescricao 
            :enfermagem="true"
            v-if="aba == 'valid'" />

        <confirmacao-de-uso-paciente v-if="aba == 'checagem-consumo'" />
        
    </div>
</template>

<script>
import Aprazamento from './Aprazamento.vue';
import Aplicacao from './Aplicacao.vue';
import AtendimentoEnfermagem from './AtendimentoEnfermagem.vue';
import PlanoInfusao from './PlanoInfusao.vue';
import ValidacaoPrescricao from './ValidacaoPrescricao.vue';
import ConfirmacaoDeUsoPaciente from '../suprimentos/ConfirmacaoDeUsoPaciente.vue';

export default {
    data() {
        return {
            dados: null,
            parms: null, 
            tem_valid: false, 
        };
    },

    props: ['aba'],

    components: { 
        Aplicacao,
        Aprazamento,
        AtendimentoEnfermagem, 
        PlanoInfusao,
        ValidacaoPrescricao,
        ConfirmacaoDeUsoPaciente
    },

    methods: { 
        abrir(aba) { 
            if ( aba != this.aba ) { 
                //this.aba = aba;
                //console.log('/enfermagem/' + aba );
                this.$router.push({ path: '/assistencia/' + aba });
            }
        },
    },

    mounted() { 
        this.$util.loadItem(this, { 
            service: 'enfermagem',
            func: 'tem_validacao', 
        })
        .then(res => { 
            this.tem_valid = res.valid;
        });
    }
}
</script>